module.exports = __webpack_public_path__ + "img/guardian_buff_shatterd_helm.24831e2d.png";